package org.example.zone360.pages.dashboard.teamSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.FaTrash
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.getAllTeams
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.SearchBar
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetAllTeamsData
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.AppGlobal.Companion.seasonDataList
import org.example.zone360.utils.AppGlobal.Companion.teamDataList
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun TeamSections(
       breakpoint: Breakpoint,
       sitePalette: SitePalette,
       teamData : List<GetAllTeamsData>,
       message: (String) -> Unit,
){
    val scope = rememberCoroutineScope()

   var isClubTeam by remember { mutableStateOf(false) }
    var deleteTeam by remember { mutableStateOf(false) }
    var selectedTeam by remember { mutableStateOf("") }
    var selectedTeamName by remember { mutableStateOf("") }
    var searchText by remember { mutableStateOf("") }

    val allowedSeasons = if (AppGlobal.userData.role == Strings.COACH) {
        val allowedSeasonIds = AppGlobal.userData.seasons.map { it.seasonID }
        seasonDataList.filter { season ->
            allowedSeasonIds.contains(season.id)
        }
    } else {
        seasonDataList
    }

    val filteredData = remember(searchText, teamData) {
        if (searchText.isEmpty()) teamData
        else teamData.filter { team ->
            val teamName = team.teamName
            teamName.contains(searchText, ignoreCase = true)
        }
    }


    if (deleteTeam){
        DeleteTeam(
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            modalNumber = 2,
            onDialogDismiss = {
                scope.launch {
                    val response = getAllTeams(
                       clubName = AppGlobal.userData.organization,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                    teamDataList.clear()
                    teamDataList.addAll(response.data)

                }
                deleteTeam = false},
            toastMessageCall = message,
            teamId = selectedTeam,
            teamName = selectedTeamName
        )
    }
    if (isClubTeam){
        CreateClubTeam(
            breakpoint = breakpoint,
            sitePalette = sitePalette,
            modalNumber = 1,
            onDialogDismiss = {
                scope.launch {
                    val response = getAllTeams(
                        clubName = AppGlobal.userData.organization,
                        seasonID = AppGlobal.selectedSeasonId
                    )
                    teamDataList.clear()
                    teamDataList.addAll(response.data)

                }
                isClubTeam = false},
            toastMessageCall = message,
            allowedSeasons = allowedSeasons
        )
    }
    Column (modifier = Modifier.height(300.px)
        .fillMaxWidth()
        .padding( 20.px)
        .backgroundColor(sitePalette.modalBackgroundColor.rgb)
        .borderRadius(15.px)
        .margin(topBottom = if (breakpoint <= Breakpoint.MD) 20.px else 0.px)){
        Row (modifier = Modifier.fillMaxWidth().margin(bottom = 5.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween) {
            SectionTitle("Teams", bottom = 0.px)

            CommonButton(
                text = "Add New Team",
                icon = { FaPlus(size = IconSize.X1,
                    modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb))},
                width = 130.px,
                height = 40.px,
                onCLick = {
                    isClubTeam = true
                })
        }
        SearchBar(
            placeholder = "Search Team...",
            id = Res.Id.searchInput,
            breakpoint = Breakpoint.LG,
            modifier = Modifier.fillMaxWidth(),
            onEnterClick = {},
            onChange = { newSearchText ->
                searchText = newSearchText
            },
            onClick = {},
            width = 100.percent,

            showClearButton = false
        )
            Row(modifier = Modifier.fillMaxWidth().margin(top = 10.px)
                .height(35.px)
                .backgroundColor(sitePalette.coachesTitleRow.rgb),
                verticalAlignment = Alignment.CenterVertically,) {
                Row(modifier = Modifier.padding(leftRight = 5.px).fillMaxSize(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween) {
                    FieldTitleTextNormalSimple(
                        text = "Team Name",
                        width = 120.px,
                        fontWeight = 500,
                        fontSize = 15.px,
                    )
                    FieldTitleTextNormalSimple(
                        text = "Action",
                        width = 60.px,
                        fontWeight = 500,
                        fontSize = 15.px,
                    )
                }

            }
            HorizontalDivider(
                modifier = Modifier.fillMaxWidth().margin(0.px).height((0.5).px)
                    .padding(leftRight = 5.px)
                    .backgroundColor(sitePalette.textFieldBorderColor.rgb)
            )
            Column(
                modifier = Modifier.fillMaxWidth().maxHeight(120.px)
                    .overflow(overflowY = Overflow.Auto, overflowX = Overflow.Hidden)
            ) {
                filteredData.forEach { data ->
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .padding(leftRight = 5.px)
                            .margin(topBottom = 10.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        FieldTitleTextNormalSimple(
                            text = data.teamName,
                            width = 90.percent,
                            fontSize = 13.px,
                            overflowWrap = OverflowWrap.Anywhere

                        )
                        Row(modifier = Modifier.width(60.px).gap(8.px),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.Center) {
                            FaTrash(size = IconSize.SM,
                                modifier = Modifier.color(sitePalette.primary.rgb)
                                    .cursor(Cursor.Pointer)
                                    .onClick {
                                        selectedTeamName = data.teamName
                                        selectedTeam = data.id
                                        deleteTeam = true
                                    })
                        }
                    }
                    HorizontalDivider(
                        modifier = Modifier.fillMaxWidth().margin(0.px).height((0.5).px)
                            .padding(leftRight = 5.px)
                            .backgroundColor(sitePalette.textFieldBorderColor.rgb)
                    )
                }

            }
        }

    }